/* eslint-disable no-param-reassign */

const callToStringAndTrim = (value) => {
  return value?.toString?.()?.trim?.();
};

// allows periods, apostrophes, and dashes
const hasLengthAndNoSymbols = (valueToCheck) => {
  valueToCheck = callToStringAndTrim(valueToCheck);
  if (!valueToCheck) return false;
  const lengthAndNoSymbolsRegex = /^[a-zA-Z0-9\s,.'-]{1,50}$/;
  return lengthAndNoSymbolsRegex.test(valueToCheck);
};

// allows periods, apostrophes, and dashes, and parentheses, and slashes
const hasLengthAndLimitedSymbols = (valueToCheck) => {
  valueToCheck = callToStringAndTrim(valueToCheck);
  if (!valueToCheck) return false;
  const lengthAndNoSymbolsRegex = /^[a-zA-Z0-9\s,&./()'-]{1,50}$/;
  return lengthAndNoSymbolsRegex.test(valueToCheck);
};

const hasLengthNoSymbolsAndNoNumbers = (valueToCheck) => {
  valueToCheck = callToStringAndTrim(valueToCheck);
  if (!valueToCheck) return false;
  const lengthNoSymbolsAndNoNumbersRegex = /^[a-zA-Z\s,.'-]{1,50}$/;
  return lengthNoSymbolsAndNoNumbersRegex.test(valueToCheck);
};

const isZipCode = (valueToCheck) => {
  valueToCheck = callToStringAndTrim(valueToCheck);
  if (!valueToCheck) return false;
  const zipCodeRegex = /^\d{5}(-\d{4})?$/;
  return zipCodeRegex.test(valueToCheck);
};

const isCanadianPostalCode = (valueToCheck) => {
  valueToCheck = callToStringAndTrim(valueToCheck);
  if (!valueToCheck) return false;
  const canadianPostalCodeRegex = /^([ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]) ?(\d[ABCEGHJKLMNPRSTVWXYZ]\d)$/i;
  return canadianPostalCodeRegex.test(valueToCheck);
};

const isPostalCode = (valueToCheck) => {
  valueToCheck = callToStringAndTrim(valueToCheck);
  if (!valueToCheck) return false;
  const postalCodeRegex = /^[A-Z\d -]{1,10}$/i;
  return postalCodeRegex.test(valueToCheck);
};

const isValidPostalCodeForCountry = (postalCode, country) => {
  if (country === 'United States') {
    return isZipCode(postalCode);
  }
  if (country === 'Canada') {
    return isCanadianPostalCode(postalCode);
  }
  return isPostalCode(postalCode);
};

const hasLength = (valueToCheck) => {
  valueToCheck = callToStringAndTrim(valueToCheck);
  if (!valueToCheck) return false;
  return valueToCheck.toString().length > 0;
};

const isEmail = (valueToCheck) => {
  valueToCheck = callToStringAndTrim(valueToCheck);
  if (!valueToCheck) return false;
  const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emailRegex.test(valueToCheck.toString());
};

// Used on sign in/pw confirmation/existing user+password actions
const isLessSecurePassword = (valueToCheck) => {
  valueToCheck = callToStringAndTrim(valueToCheck);
  if (!valueToCheck) return false;
  const passwordRegex = /^.{6,}$/;
  return passwordRegex.test(valueToCheck);
};

// Used on sign up/password change/password reset/new user or password actions
const isPassword = (valueToCheck) => {
  valueToCheck = callToStringAndTrim(valueToCheck);
  if (!valueToCheck) return false;
  const passwordRegex = /^.{10,128}$/;
  return passwordRegex.test(valueToCheck);
};

const emptyOrNoSymbols = (valueToCheck) => {
  valueToCheck = callToStringAndTrim(valueToCheck);
  if (!valueToCheck) return true;
  const regex = /^[a-zA-Z0-9\s,.#'-]*$/;
  return regex.test(valueToCheck);
};

const onlyNumbers = (valueToCheck) => {
  valueToCheck = callToStringAndTrim(valueToCheck);
  if (!valueToCheck) return false;
  const regex = /^[0-9-]{5,}$/;
  return regex.test(valueToCheck);
};

const isPhoneNumber = (valueToCheck) => {
  valueToCheck = callToStringAndTrim(valueToCheck);
  if (!valueToCheck) {
    return false;
  }
  const regex = /^\d{10,14}$/;
  return regex.test(valueToCheck.toString());
};

const isCorporatePassword = (valueToCheck) => {
  valueToCheck = callToStringAndTrim(valueToCheck);
  if (!valueToCheck) return false;
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_=+,<.>/?`~|{}[\]\\-])[A-Za-z\d!@#$%^&*()_=+,<.>/?`~|{}[\]\\-]{12,}$/;
  return passwordRegex.test(valueToCheck);
};

const isPoBoxAddress = (valueToCheck) => {
  valueToCheck = callToStringAndTrim(valueToCheck);
  if (!valueToCheck) return false;
  const poBoxRegex = /\bP(ost|ostal)?([ .]*(O|0)(ffice)?)?([ .]*Box)\b/i;
  if (!valueToCheck) return false;
  return poBoxRegex.test(valueToCheck);
};

module.exports = {
  hasLengthAndNoSymbols,
  hasLengthAndLimitedSymbols,
  hasLengthNoSymbolsAndNoNumbers,
  isZipCode,
  isValidPostalCodeForCountry,
  hasLength,
  isEmail,
  isLessSecurePassword,
  isPassword,
  isCorporatePassword,
  emptyOrNoSymbols,
  onlyNumbers,
  isPhoneNumber,
  isPoBoxAddress,
};
